module.exports = __webpack_public_path__ + "img/color_bloc_black.6e21ac24.jpeg";